export default __webpack_public_path__ + "static/media/Rare_Transition.5aafa510.webm";